import { baseCrudFactory } from "~/stores/base.crud.store"
import { useProjetStore, useAdresseStore } from "~/stores"
import { mapById } from "~/helpers"
import { ClientModel } from "~/model"
import { Api } from "~/api/Api"

export const useClientStore = baseCrudFactory({
    endpoint: "clients",
    primaryKey: "IDCLIENT",
    model: ClientModel,
    modules: {
        projets: () => useProjetStore(),
        adresse: () => useAdresseStore(),
    },
    title: "client",
    showDelete: false,
    getters: {
        clientByIdAdresse() {
            return mapById(this.items, "IDADRESSE")
        },
    },
    actions: {
        async create(formItem: any = null) {
            formItem = formItem || this.formItem
            Object.keys(formItem).forEach((key) => {
                if (!formItem[key]) {
                    delete formItem[key]
                }
            })
            const response = await Api.client.clientsStore(
                "false",
                "true",
                formItem,
            )
            this.setItems(response, false)
            return response.IDCLIENT
        },
    },
})
